import { useEffect, useState } from "react";
import UsagePercent from "./UsagePercent";

export default function Utilization({ asyncFunction }) {
  const [docs, setDocs] = useState(null);
  const [didClick, setDidClick] = useState(false);
  const [copied, setCopied] = useState("");

  const handleQueryDocsUtilization = async () => {
    setDidClick(true);
    setDocs(await asyncFunction());
  }

  const copyToClipboard = async (e) => {
    navigator.clipboard.writeText(e.target.innerText);

    setCopied(`Successfully copied: ${e.target.innerText}`);

    setTimeout(() => {
      setCopied("");
    }, 1000);
  }

  return (
    <>
      {docs !== null ? (
        <div className='w-full max-h-[400px] relative mb-4 overflow-y-auto'>
          <table className='w-full'>
            <thead>
              <tr className='py-2 px-4 sticky top-0 bg-white'>
                <th className='border-b w-[12%] text-left'>#</th>
                <th className='border-b w-[28%] text-left'>Name</th>
                <th className='border-b w-[30%] text-left'>Email</th>
                <th className='border-b w-[15%] text-center'>Notes</th>
                <th className='border-b w-[15%] text-left'>Usage</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((doc, i) => (
                <tr className='py-2 px-4 hover:bg-light-purple' key={i}>
                  <td className=''>{i + 1}</td>
                  <td className=''>{doc.user_name}</td>
                  <td className='relative w-[20%] max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap'>
                    <button onClick={copyToClipboard}>{doc.user_email}</button>
                  </td>
                  <td className='text-center'>{doc.notes}</td>
                  <td className=''><UsagePercent doctor_id={doc.user_id} /></td>
                </tr>
              ))}
            </tbody>
          </table>
          {copied && (
            <div className='fixed bottom-6 right-6 max-w-[300px] bg-white shadow-knowtex-shadow rounded-md p-3 z-100'>
              {copied}
            </div>
          )}
        </div>
      )
        :

        didClick ?
          <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple mx-auto mb-2"></span >
          :
          <button className="w-auto rounded-md border-sage-green border-[1px] text-sage-green hover:bg-sage-green hover:text-white font-semibold py-2 px-4 mb-2" onClick={handleQueryDocsUtilization}>Query Weekly Utilization</button >
      }

    </>
  );
}